import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import BlogForm from "shared/components/dashboard/blogForm";
import { Blog, BlogFormData } from "shared/types/blog";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: (data: BlogFormData) => void;
  initialData?: Blog;
  loading?: boolean;
}

const BlogFormModal = ({
  show,
  handleClose,
  onSubmit,
  initialData,
  loading,
}: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div className="flex items-center justify-between px-4 mt-4 mb-3">
          <h3 className="text-lg font-medium text-gray-900">
            {initialData ? "Edit Blog" : "Create New Blog"}
          </h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              if (!loading) {
                handleClose();
              }
            }}
          >
            <Icons.Cross />
          </div>
        </div>
        <div className={classNames(styles.modalBody, "w-full")}>
          <BlogForm
            initialData={initialData}
            onSubmit={onSubmit}
            onCancel={handleClose}
            loading={loading}
          />
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default BlogFormModal;
